var map = {
	"./1/symbol_0.png": 77381,
	"./1/symbol_1.png": 43516,
	"./1/symbol_10.png": 66694,
	"./1/symbol_11.png": 48239,
	"./1/symbol_12.png": 26772,
	"./1/symbol_2.png": 48599,
	"./1/symbol_3.png": 58606,
	"./1/symbol_4.png": 41697,
	"./1/symbol_5.png": 68984,
	"./1/symbol_6.png": 43475,
	"./1/symbol_7.png": 92714,
	"./1/symbol_8.png": 69309,
	"./1/symbol_9.png": 48180,
	"./2/symbol_0.png": 80584,
	"./2/symbol_1.png": 74449,
	"./2/symbol_10.png": 62834,
	"./2/symbol_11.png": 4540,
	"./2/symbol_12.png": 12119,
	"./2/symbol_2.png": 69690,
	"./2/symbol_3.png": 17443,
	"./2/symbol_4.png": 57548,
	"./2/symbol_5.png": 93461,
	"./2/symbol_6.png": 7710,
	"./2/symbol_7.png": 60199,
	"./2/symbol_8.png": 59104,
	"./2/symbol_9.png": 37225,
	"./3/symbol_0.png": 96603,
	"./3/symbol_1.png": 81778,
	"./3/symbol_10.png": 20392,
	"./3/symbol_12.png": 92538,
	"./3/symbol_2.png": 96393,
	"./3/symbol_3.png": 18272,
	"./3/symbol_4.png": 69599,
	"./3/symbol_5.png": 72662,
	"./3/symbol_6.png": 86637,
	"./3/symbol_7.png": 32740,
	"./3/symbol_8.png": 76611,
	"./3/symbol_9.png": 28858,
	"./4/symbol_0.png": 41646,
	"./4/symbol_1.png": 41143,
	"./4/symbol_10.png": 41111,
	"./4/symbol_12.png": 69893,
	"./4/symbol_2.png": 33564,
	"./4/symbol_3.png": 69477,
	"./4/symbol_4.png": 99050,
	"./4/symbol_5.png": 30963,
	"./4/symbol_6.png": 19000,
	"./4/symbol_7.png": 40129,
	"./4/symbol_8.png": 28614,
	"./4/symbol_9.png": 10159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72515;